import { Box, HStack, Text } from '@chakra-ui/react';
import { CQReactTable, TextInput } from '@laxmimanogna/code-quick-components';
import React from 'react';
import { SearchIcon } from '../../../../constants/IconData';
import { defaultReactTableProp } from '../../../../utils/assigned_audit.util';

const RightContainer = props => {
  const { columns, tableProps, data = [], isLoading, renderMiddleContent, onSearchChange } = props
  const { sectionTitle, onSearch } = props

  // boolean

  function handleSearch(e) {
    if (onSearch && e.keyCode === 13) {
      onSearch(e.target.value);
    }
  }


  return (
    <React.Fragment>
      <HStack justifyContent={'space-between'}>
        <Box flex={2}>
          <Text textTransform={'uppercase'} fontSize={'md'} fontWeight={'bold'}>{sectionTitle}</Text>
        </Box>

        {renderMiddleContent && renderMiddleContent()}
        <Box flex={1}>
          <TextInput
            wrapperProps={{ bg: 'transparent' }}
            bg={'white'}
            height={'50px'}
            rightIconProps={{ zIndex: 0 }}
            placeholder="Search"
            rightIcon={<SearchIcon />}
            onKeyDown={handleSearch}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </Box>
      </HStack>

      <Box my={4} p={4} bgColor={"#fff"} borderRadius={'lg'} shadow={'lg'}>
        <CQReactTable
          {...defaultReactTableProp}
          {...tableProps}
          isLoading={isLoading}
          columns={columns}
          data={data}
        />
      </Box>
    </React.Fragment>
  );
};

export default React.memo(RightContainer);
